import { AmenitiesTableconstant } from "./AmenitiesTableConstant";

const AmenitiesTableAction = {};

AmenitiesTableAction.getAmenitiesTable = () => {
  return {
    type: AmenitiesTableconstant.AMENITIES_TABLE_SAGA,
  };
};

AmenitiesTableAction.PostAmenitiesAction = (payload) => {
  return {
    type: AmenitiesTableconstant.POST_AMENITIES_SAGA,
    payload: payload,
  };
};

AmenitiesTableAction.UdateAmenitiesAction = (payload) => {

  return {
    type: AmenitiesTableconstant.UPDATE_AMENITIES_SAGA,
    payload: payload,
  };
};

//ENABLE DESABLE ACTION
AmenitiesTableAction.AmenitiesEnableDisable = ({ id, status }) => {
  return {
    type: AmenitiesTableconstant.ENABLE_DESABLE_AMENITIES_SAGA,
    payload: { id, status },
  };
};

export { AmenitiesTableAction };
